import { sortBy } from 'lodash';
import apiCall from 'shared/utils/apiCall';
import apolloClient from 'store/apolloClient';
import errorAction from 'shared/utils/errorAction';
import createAsyncAction from 'shared/utils/createAsyncAction';


import createAction from '../actions';
import * as services from '../services/services';

export const FETCH_SERVICES = createAsyncAction(createAction('FETCH_SERVICES'));

export const fetchServices = () => (dispatch) => {
  dispatch({ type: FETCH_SERVICES.pending });

  const apiCallParams = {
    query: services.FETCH_SERVICES,
    fetchPolicy: 'no-cache',
  };

  return apiCall(apolloClient.query, apiCallParams)
    .then(({ data: { appointmentServices } }) => {
      const tempAppointmentServices = sortBy(appointmentServices, [(service) => service.name.toLowerCase()]);
      dispatch({
        type: FETCH_SERVICES.success,
        payload: { appointmentServices: tempAppointmentServices },
      });
    })
    .catch(err => dispatch(errorAction(FETCH_SERVICES.failure, err)));
};
